<!--
    Program: RequestOther.vue
    Author: SDL
    Description:
    Created: 2020.03.20
-->

<template>
    <div id="contents">
        <div class="contents_wrap">
            <h2 class="pg_title">Other Request</h2>
            <!-- breadcrumbs -->
            <div class="bc_ico">
                Home
                <em>
                    <span class="sr_only">&gt;</span>
                </em>Engineer
                <em>
                    <span class="sr_only">&gt;</span>
                </em> Mobile SVC
                <em>
                    <span class="sr_only">&gt;</span>
                </em>Other Request
            </div>
            <!-- //breadcrumbs -->
            <!-- Basic tit -->
            <div class="sub_tit">Basic</div>
            <!-- //Basic tit -->
            <!-- detail_Basic -->
            <table class="create_table">
                <colgroup>
                    <col width="16%" />
                    <col width="*" />
                    <col width="18%" />
                    <col width="*" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>
                            Name
                            <em class="txt_mandatory">*</em>
                        </th>
                        <td>
                            <span class="clearable">
                                <input
                                    type="text"
                                    class="text_input w100"
                                    placeholder
                                    maxlength="30"
                                    v-model="name"
                                    v-validation
                                    v-clearable
                                />
                            </span>
                        </td>
                        <th>
                            English Name
                            <em class="txt_mandatory">*</em>
                        </th>
                        <td>
                            <span class="clearable">
                                <input
                                    type="text"
                                    class="text_input w100"
                                    placeholder
                                    maxlength="30"
                                    v-model="engName"
                                    v-validation
                                    v-clearable
                                />
                            </span>
                        </td>
                    </tr>
                    <!--
                    <tr>
                        <th>
                            Cell Phone #
                            <em class="txt_mandatory">*</em>
                        </th>
                        <td>
                            <span>
                                <input
                                    type="text"
                                    class="text_input w100"
                                    placeholder
                                    maxlength="20"
                                    v-model="cellPhoneNo"
                                    v-validation
                                    v-clearable
                                />
                            </span>
                        </td>
                        <th>
                            Office Phone #
                            <em class="txt_mandatory">*</em>
                        </th>
                        <td>
                            <span>
                                <input
                                    type="text"
                                    class="text_input w100"
                                    placeholder
                                    maxlength="20"
                                    v-model="officePhoneNo"
                                    v-validation
                                    v-clearable
                                />
                            </span>
                        </td>
                    </tr>
                    -->
                </tbody>
            </table>
            <div class="btn_wrap_full topLine"></div>
            <!-- //detail_Basic -->

            <!-- Information tit -->
            <div class="sub_tit mt40">Request Information</div>
            <!-- //Information tit -->
            <!-- detail_Information -->
            <table class="create_table">
                <colgroup>
                    <col width="16%" />
                    <col width="40%" />
                    <col width="*" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>Request Type
                        <em class="txt_mandatory">*</em>
                        </th>
                        <td>
                            <select class="slt_white w100" v-model="selectedRequestType">
                                <option
                                    v-for="item in availableRequestTypeList"
                                    :key="item.CODE_ID"
                                    :value="item.CODE_ID"
                                >{{item.CODE_NAME}}</option>
                            </select>
                        </td>
                        <td></td>
                    </tr>
                    <tr v-if="isImeiPwdVisible">
                        <th>ESN/IMEI Writing P/W
                            <em class="txt_mandatory">*</em>
                        </th>
                        <td>
                            <span>
                                <input
                                    type="password"
                                    class="text_input w100"
                                    minlength="10"
                                    maxlength="20"
                                    placeholder
                                    v-model="imeiPwd"
                                    v-validation
                                    v-clearable
                                />
                            </span>
                        </td>
                        <td>
                            <a @click="showPasswordRules" href="javascript:">
                                <span class="ico_sech_sm">search아이콘</span>
                                View Password Rules
                            </a>
                        </td>
                    </tr>
                    <tr v-if="isImeiPwdVisible">
                        <th>ESN/IMEI Confirm P/W
                            <em class="txt_mandatory">*</em>
                        </th>
                        <td>
                            <span class="clearable">
                                <input
                                    type="password"
                                    class="text_input w100"
                                    minlength="10"
                                    maxlength="20"
                                    placeholder
                                    v-model="imeiPwdConfirm"
                                    v-validation
                                    v-clearable
                                />
                            </span>
                        </td>
                        <td></td>
                    </tr>
                    <tr v-if="['006', '007'].includes(selectedRequestType) ">
                        <th>Country</th>
                        <td>
                            <select class="slt_white w100" v-model="selectedCountry" @change="onCountryChange" v-validation>
                                <option
                                    v-for="item in availableCountryList"
                                    :key="item.CODE_ID"
                                    :value="item.CODE_ID"
                                >{{item.CODE_NAME}}</option>
                            </select>
                        </td>
                        <td></td>
                    </tr>
                    <tr v-if="selectedRequestType === '008'">
                        <th>User Role</th>
                        <td>
                            <select class="slt_white w100" v-model="selectedUserRole">
                                <option
                                    v-for="item in availableUserRoleList"
                                    :key="item.CODE_ID"
                                    :value="item.CODE_ID"
                                >{{item.CODE_NAME}}</option>
                            </select>
                        </td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
            <!-- //detail_Information -->
            <!-- page btn -->
            <div class="btn_wrap_full topLine">
                <div class="btn_right">
                    <a @click="onRequestBtnClick" class="btn_blue" title>Request</a>
                </div>
            </div>
            <!-- //page btn -->
        </div>
    </div>
</template>

<script>
import Vue   from 'vue';
import axios from 'axios';
// import $ from 'jquery';

import qs from 'query-string';
// import moment from 'moment';

import { SDLUtil, DateUtil } from '@/utils';

// import DatePicker from '~c/DatePicker';

// import HhpCerts from '~c/HhpCerts';

// import Pagination from '@/components/common/control/pagination/Pagination';
// import ToastGrid from '~c/ToastGrid';

/**
 * Rules to follow
 *
 * 	if(KRC_CHECK == "N") {
		$("select[name='change_country_cd']>option[value='KR']").attr('disabled', 'true');
    }

    if roleCD == A08
        REQ TYPE CD 006 -> Remove
        REQ TYPE CD 008 -> Remove
        REQ TYPE CD 004 -> Unlock the reactivation Unlock

    countryCheck
        approvalYN != Y
            Avaliable for each city or users who do not have permission.
    lockCheck
        directMonthLockYN == Y
            Unlock the 1-month lock you haven't logged in to your account for more than a month.
            Please unlock the account by using Other request in Mobile SVC.


 *
 */

const RolesImeiPassHidden = ['S01', 'S02', 'S03', 'S04', 'S05'];

export default {
    name: 'hhp-request-other',
    components: {},
    props: [],
    computed: {
        isImeiPwdVisible() {
            return (
                ['003', '004'].includes(this.selectedRequestType) &&
                !RolesImeiPassHidden.includes(this.userData.ROLE_CD)
            );
            // && !['S01', 'S02', 'S03', 'S04',].includes(this.userData.ROLE_CD);
        },
    },
    data() {
        return {
            name: '',
            engName: '',
            cellPhoneNo: '',
            officePhoneNo: '',

            longPermissionFlag : 'N',
        
            availableRequestTypeList: [],
            availableCountryList: [],
            availableUserRoleList: [],

            selectedRequestType: '',
            selectedCountry: '',
            selectedUserRole: '',

            imeiPwd: '',
            imeiPwdConfirm: '',

            directMonthLockYN: 'N',
            monthLockYN: 'N',

            userData: {},
        };
    },
    created() {
        this.init();
    },
    mounted() {},
    methods: {
        async init() {
            SDLUtil.showLoadingBar(true);
            const data = await this.fetchInitData();
            SDLUtil.showLoadingBar(false);
            if (data === false) {
                return;
            }
            this.setDirectMonthLockYN(data.directMonthLockYN || 'N');
            this.setUserData(data.userData[0]);
            this.setAvailableCountryList(data.reqCountryList);
            this.setAvailableUserRoleList(data.reqRoleList);
            this.setAvailableRequestTypeList(data.reqTypeList);
            this.monthLockYN = data.monthLockYN;
            
            this.applyPageRules();

            this.checkAccess();
            this.checkLock();

        },
        
	    /**
	     * When the user switches countries, trigger this check.
	     * Only when the request type is '007' should the system verify whether the selected country already has permanent permission.
	     */
	    async onCountryChange() {
	      if (this.selectedRequestType !== '007') {
	        return;
	      }
	      // selectedCountry with v-model update）
	      let param = { selectedCountry : this.selectedCountry };
	      try {
	        //Get request
	        const resp = await axios.get(
	          `${SDLUtil.API_URL}/basis/anysvcmobile/request/RequestTemPermissionData.skp`,
	          {
	        	params: { ...param, searchInfo: 'set' },
	          }
	        );
	        this.longPermissionFlag = resp.data.longPermCountry; // Default is 'N'
	
	        if (this.longPermissionFlag === 'Y') {
	          await SDLUtil.alert({
	            title: 'Country Permission(s)',
	            msg: 'The selected country already has permanent permissions.'
	          });
	        }
	      } catch (err) {
	    	  console.log('Error occurred : ', err);
	      }
	    },
        
        checkAccess() {
            if (this.userData.APPROVAL_YN !== 'Y') {
                SDLUtil.alert({
                    title: 'No Access',
                    msg:
                        'You currently do not have an access to Mobile Service.' +
                        '<br>You can request an access to Mobile Svc via Mobile Authorization > Access Request.' +
                        '<br>If you already got an approval, make sure you are trying to access the approved country.',
                    okLabel: 'OK',
                    onOkEvt: () => {
                        // this.$router.push({ path: '/basis/anysvcmobile/request/RequestCert' });
                    },
                });
                return;
            }
            // function countryCheck() {
            //     var result = true;
            //     if ($("input[name='approval_yn']").val() != "Y") {
            //         var str = "Available for each city or users who do not have permission.\n";
            //         str += "Please contact your administrator.";
            //         alert(str);
            //         result = false;
            //     }
            //     return result;
            // }
        },
        checkLock() {
            if (this.directMonthLockYN === 'N'
                && this.monthLockYN === 'N') return;

            const title = `[ 1 Month Inactivity Lock ]`;
            SDLUtil.alert({
                title,
                msg: `Your account has been locked due to prolonged inactivity.<br>
                    Please request an unlock via Other Request.`,
                onOkEvt: () => {
                    this.selectedRequestType = 'Select';
                },
            });

            //     if (directMonthLockYN == "") {
            //         alert("Server Error!!\nPlease contact your administrator.");
            //     } else if (directMonthLockYN == "Y") {
            //         str += "[ Unlock the 1-month lock ]\nYou didn\'t login your account during a month.";
            //         str += "\nPlease unlock the account by using Oher request in Mobile SVC.";
            //         alert(str);
            //     }
        },
        
        fetchInitData() {
            const path = '/basis/anysvcmobile/request/RequestOther.skp';
            return SDLUtil.getRequest(path)
                .catch(err => {
                    if (err.data.error.code === 'HHP_LOGIN_REQUIRED') {
                        return SDLUtil.getRequest(path);
                    } else if (err.data.error.code === 'HHP_MONTH_LOCK') {
                        return SDLUtil.getRequest(path);
                    } else if (err.data.error.code === 'HHP_CERT_REQUIRED') {
                        SDLUtil.alert({
                            title: 'Access Denied!',
                            msg: 'Please Request access to Mobile SVC first.',
                            onOkEvt: () => {
                                this.$router.push({name: 'anysvcCertLogin'});
                            },
                        })
                        return false;
                    }

                    return false;
                });
                // .then(res => {
                // return (
                //     axios
                //         // Loads data such as list of countries, etc...
                //         .get(`${SDLUtil.API_URL}/basis/anysvcmobile/request/RequestOther.skp`)
                //         .then(res => {
                //             if (typeof res.data.userData === 'undefined' || res.data.userData.length !== 1) {
                //                 return Promise.reject(Object.assign(res, new Error('invalid data')));
                //             }
                //             console.log('RequestOther', res.data);
                //             return res.data;
                //         })
                //         .catch(err => {
                //             Vue.$log.error('Request Other Error', err);
                //             return err;
                //         })
                // );

                // })
        },

        setUserData(userData) {
            console.log('USER DATA', userData);
            // userData.ROLE_CD = 'A01'; // Test code
            this.userData = userData;
            this.name = userData.NAME;
            this.engName = userData.ENAME;
            this.cellPhoneNo = userData.PHONE_CELL_NO;
            this.officePhoneNo = userData.PHONE_OFFICE_NO;

            // ENAME: " "
            // G_ACCOUNT_NO: "0000012345"
            // G_LOGIN_CORP: "C100"
            // EMAIL: " "
            // NAME: " "
            // COUNTRY_CD: "KR"
            // TYPE_CD: "001"
            // IMEI_PASS: " "
            // ROLE_CD: " "
            // KRC_CHECK: "Y"
            // APPROVAL_YN: "Y"
            // PHONE_CELL_NO: "1234567"
            // PHONE_OFFICE_NO: "1234567"
        },
        setDirectMonthLockYN(directMonthLockYN) {
            this.directMonthLockYN = directMonthLockYN;
        },

        setAvailableCountryList(list) {
            this.availableCountryList = list.map(item => {
                return {
                    CODE_NAME: item[0].replace(/"/g, ''),
                    CODE_ID: item[1].replace(/"/g, ''),
                };
            });
            this.selectedCountry = this.availableCountryList[0].CODE_ID;
        },
        setAvailableUserRoleList(list) {
            this.availableUserRoleList = list.map(item => {
                return {
                    CODE_NAME: item[0].replace(/"/g, ''),
                    CODE_ID: item[1].replace(/"/g, ''),
                };
            });
            this.selectedUserRole = this.availableUserRoleList[0].CODE_ID;
        },
        setAvailableRequestTypeList(list) {
            this.availableRequestTypeList = list.map(item => {
                return {
                    CODE_NAME: item[0].replace(/"/g, ''),
                    CODE_ID: item[1].replace(/"/g, ''),
                };
            });
            this.selectedRequestType = this.availableRequestTypeList[0].CODE_ID;
        },

        applyPageRules() {
            //C20030008334 주석처리
            //  * 	if(KRC_CHECK == "N") {
            // 		$("select[name='change_country_cd']>option[value='KR']").attr('disabled', 'true');
            //     }
            // Remove Korea
            // if (this.userData.KRC_CHECK === 'N') {
            //     this.availableCountryList = this.availableCountryList.filter(item => item.CODE_ID !== 'KR');
            // }

            // if roleCD == A08
            //     REQ TYPE CD 006 -> Remove
            //     REQ TYPE CD 008 -> Remove
            //     REQ TYPE CD 004 -> Unlock the reactivation Unlock
            const toChangeLabel = '004';
            const toRemove = ['006', '008'];
            if (this.userData.ROLE_CD === 'A08') {
                this.availableRequestTypeList = this.availableRequestTypeList.filter(
                    item => !toRemove.includes(item.CODE_ID),
                );
                const index = this.availableRequestTypeList.findIndex(item => item.CODE_ID === toChangeLabel);
                if (index > -1) {
                    this.availableRequestTypeList[index].CODE_NAME = 'Unlock the reactivation unlock';
                }
            }
        },

        onRequestBtnClick() {
            this.submitForm();
        },

        async submitForm() {
            if (!this.validateFormData()) return;
            const formData = this.prepFormData();
            SDLUtil.showLoadingBar(true);
            const result = await this.postForm(formData)
                .catch(err => {
                    if (err.data) {
                        if (err.data.error.code === 'HHP_INVALID_REQUEST') {
                            SDLUtil.alert({
                                title: 'Request Failed!',
                                msg: 'Failed to submit the request.<br>'+
                                    err.data.error.message
                                + '<br>Please try again.',
                            });
                        }
                    }
                    return null;
                });
            SDLUtil.showLoadingBar(false);

            if (!result) {
                console.log('RESULT', result);
                SDLUtil.alert({
                    title: 'Request Failed!',
                    msg: 'Failed to submit the request.<br>Please try again.',
                });
                return;
            }

            SDLUtil.alert({
                title: 'Success!',
                msg:
                    "Your request has been submitted.<br>Please check the status of the request<br>on 'Mobile svc Request Status' Page.",
                okLabel: 'Go to Request Status Page',
                onOkEvt: () => {
                    this.$router.push({ path: '/basis/anysvcmobile/request/Request' });
                },
            });
        },

        validateFormData() {
            if (this.name.trim().length === 0) {
                SDLUtil.alert({
                    title: 'Invalid input',
                    msg: 'Please enter name.',
                });
                return false;
            }

            if (this.engName.trim().length < 3) {
                SDLUtil.alert({
                    title: 'Invalid input',
                    msg: 'Please enter English name.',
                });
                return false;
            }

            if (this.selectedRequestType.toUpperCase() === 'SELECT') {
                SDLUtil.alert({
                    title: 'Invalid input',
                    msg: 'Please select a type of request.',
                });
                return false;
            }

            if (['003', '004'].includes(this.selectedRequestType)) {
                if (this.isImeiPwdVisible) {
                    if (this.imeiPwd !== this.imeiPwdConfirm) {
                        SDLUtil.alert({
                            title: 'ESN/IMEI Password',
                            msg: 'Passwords not matching.',
                        });
                        return false;
                    }

                    if (!this.validateImeiPwd(this.imeiPwd, '', this.userData.EMAIL, this.userData.ENAME)) {
                        return false;
                    }
                }
            }

            if (['006', '007'].includes(this.selectedRequestType)) {
                if (this.selectedCountry === this.availableCountryList[0].CODE_ID) {
                    SDLUtil.alert({
                        title: 'Country List',
                        msg: 'Please select a country.',
                    });
                    return false;
                }
                
                if (this.longPermissionFlag === 'Y') {
      	            SDLUtil.alert({
	      	            title: 'Country Permission(s)',
	      	            msg: 'The selected country already has permanent permissions.'
	      	        });
      	         	return false;
      	        }
            }
            
            if (this.selectedRequestType === '008') {
                if (this.selectedUserRole === this.availableUserRoleList[0].CODE_ID) {
                    SDLUtil.alert({
                        title: 'User Role',
                        msg: 'Please select a User Role.',
                    });
                    return false;
                }
            }
            /*
            if (SDLUtil.isNull(this.cellPhoneNo)) {
                SDLUtil.alert({
                    title: 'Cell Phone Number',
                    msg: 'Please enter a cell phone number.',
                });
                return false;
            }

            if (SDLUtil.isNull(this.officePhoneNo)) {
                SDLUtil.alert({
                    title: 'Office Phone Number',
                    msg: 'Please enter an office phone number.',
                });
                return false;
            }
            */
            return true;
        },

        validateImeiPwd(pwd, loginId = '', email = '', name = '') {
            const strNewPwd = pwd;
            const strUserID = loginId;
            const strEmail = email;

            // PART
            const strName = name;
            const nowDate = new Date();
            const year = String(nowDate.getYear());
            const year_prev = String(nowDate.getYear() - 1);
            const year_next = String(nowDate.getYear() + 1);

            let strEmailId = '';
            let strEmailCompany = '';

            const idx_email_id = email.indexOf('@');
            if (idx_email_id > -1) {
                strEmailId = email.substring(0, idx_email_id);
                const idx_email_company = email.indexOf('.');
                if (idx_email_company > -1) {
                    strEmailCompany = email.substring(idx_email_id + 1, idx_email_company);
                }
            }

            // FULL
            const FORBIDDEN_WORDS = [
                strUserID.toUpperCase(),
                strName.toUpperCase(),
                'SAMSUNG',
                'GSPN',
                'SERVICE',
                'SERVICIO',
                'IMEI',
                'ESN',
                'PASSWORD',
                year,
                year_prev,
                year_next,
                strEmailId.toUpperCase(),
                strEmailCompany.toUpperCase(),
                '1QAZXSW23E',
                '12QWERASDF',
                '12QWASZX3E',
                'ASDFQWER12',
                'ASDF',
                'QWER',
                'ZXCV',
            ];

            const RULES = [
                {
                    condition: pwd => !pwd,
                    msg: 'The ESN/IMEI password is required.',
                },
                {
                    condition: pwd => pwd.length < 10,
                    msg: 'The password must be 10 or more characters.',
                },
                {
                    condition: pwd => !pwd.match(/(.[a-zA-Z].[0-9])|(.[0-9].[a-zA-Z])/),
                    msg: 'The password must be alphanumeric',
                },
                {
                    condition: pwd => pwd.match(/([&,%,>,<,',",;,},{,|])/),
                    msg: 'The password cannot contain the following special characters. e.g. & % > < \' " ; } { |',
                },
                {
                    condition: pwd => !pwd.match(/([!,@,#,$,^,*,?,_,~])/),
                    msg: 'The password must contain one of the following special characters. e.g. ! @ # $ ^ * ? _ ~',
                },
                {
                    condition: pwd => {
                        const pwdUpperCase = pwd.toUpperCase();
                        for (var i = 0; i < FORBIDDEN_WORDS.length; i++) {
                            if (!FORBIDDEN_WORDS[i]) continue;
                            if (pwdUpperCase.includes(FORBIDDEN_WORDS[i])) {
                                return `The password cannot contain a word "${FORBIDDEN_WORDS[i]}"`;
                            }
                        }
                        return false;
                    },
                    msg: '',
                },
                {
                    condition: pwd => {
                        let samePwd_0 = 0; //동일문자 카운트
                        let samePwd_1 = 0; //연속성(+) 카운트
                        let samePwd_2 = 0; //연속성(-) 카운트

                        let chr_pass_0, chr_pass_1, chr_pass_2, chr_pass_3;
                        const pwdLength = pwd.length;

                        for (let i = 0; i < pwdLength; i++) {
                            chr_pass_0 = pwd.charAt(i);
                            chr_pass_1 = pwd.charAt(i + 1);
                            chr_pass_2 = pwd.charAt(i + 2);
                            chr_pass_3 = pwd.charAt(i + 3);

                            //동일문자 카운트
                            if (chr_pass_0 == chr_pass_1 && chr_pass_0 == chr_pass_2 && chr_pass_0 == chr_pass_3) {
                                samePwd_0++;
                            }

                            //연속성(+) 카운드
                            if (
                                chr_pass_0.charCodeAt(0) - chr_pass_1.charCodeAt(0) == 1 &&
                                chr_pass_1.charCodeAt(0) - chr_pass_2.charCodeAt(0) == 1
                            ) {
                                samePwd_1++;
                            }

                            //연속성 역순(-) 카운드
                            if (
                                chr_pass_0.charCodeAt(0) - chr_pass_1.charCodeAt(0) == -1 &&
                                chr_pass_1.charCodeAt(0) - chr_pass_2.charCodeAt(0) == -1
                            ) {
                                samePwd_2++;
                            }
                        }
                        if (samePwd_0 > 0) {
                            return 'A repetition of 3 consecutive characters or more is not permitted. (i.e. 1111, aaaa).';
                        }

                        if (samePwd_1 > 0 || samePwd_2 > 0) {
                            return 'No more than 3 consecutive numbers or characters. (i.e. 123, bca).';
                        }

                        return false;
                    },
                    msg: '',
                },
            ];

            const title = 'Password Rule';
            const isValid = RULES.every(rule => {
                const isInvalid = rule.condition(strNewPwd); // isInvalid: Boolean | String
                if (isInvalid) {
                    const msg = typeof isInvalid === 'string' ? isInvalid : rule.msg;
                    SDLUtil.alert({ title, msg });
                    return false; // Stops the loop
                }
                return true;
            });

            return isValid;
        },

        prepFormData() {
            // ENAME: " "
            // G_ACCOUNT_NO: "0000012345"
            // G_LOGIN_CORP: "C100"
            // EMAIL: " "
            // NAME: " "
            // COUNTRY_CD: "KR"
            // TYPE_CD: "001"
            // IMEI_PASS: " "
            // ROLE_CD: " "
            // KRC_CHECK: "Y"
            // APPROVAL_YN: "Y"
            // PHONE_CELL_NO: "1234567"
            // PHONE_OFFICE_NO: "1234567"
            const formData = {
                type_cd: this.selectedRequestType,
                imei_pass: this.userData.IMEI_PASS || '',
                country_cd: this.userData.COUNTRY_CD,
                role_cd: this.userData.ROLE_CD,
                approval_yn: this.userData.APPROVAL_YN,
                G_LOGIN_CORP: this.userData.G_LOGIN_CORP || '',
                G_ACCOUNT_NO: this.userData.G_ACCOUNT_NO || '',
                G_SHIP_TO_CODE: this.userData.G_SHIP_TO_CODE || '',
                purpose: '',
                name: this.name,
                ename: this.engName,
                phone_cell_no: this.cellPhoneNo || '',
                phone_office_no: this.officePhoneNo || '',
                email: this.userData.EMAIL || '',
                change_country_cd: this.selectedCountry,
                change_role_cd: this.selectedUserRole,
                change_imei_pass: this.imeiPwd,
            };
            return formData;
        },

        postForm(formData) {
            // Form Data
            return axios
                .post(`${SDLUtil.API_URL}/basis/anysvcmobile/request/RequestOtherProc.skp`, qs.stringify(formData), {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                })
                .then(resp => {
                    console.log('POST FORM RESULT =>> ', resp);
                    return resp.data.result;
                });

            // imei_pass:
            // country_cd:
            // role_cd:
            // approval_yn:
            // directMonthLockYN:
            // G_LOGIN_PWD:
            // G_LOGIN_CORP: C100
            // G_ACCOUNT_NO: 0000012345
            // G_SHIP_TO_CODE:
            // purpose:
            // name:
            // ename:
            // phone_cell_no: 12345678
            // phone_office_no: 12345678
            // email:
            // type_cd: 009
            // change_country_cd: KR
            // change_role_cd: Select
            // change_imei_pass:
        },

        showPasswordRules() {
            let str = "1) The password's minimum length is 10<br>";
            str += '2) The password must be different from the previous<br>';
            str += '3) The password must contain the special character ! @ # $ ^ * ? _ ~<br>';
            str += '4) No more than 3 consecutive numbers or characters<br>';
            str += '5) The password cannot contain the user ID<br>';
            str += '6) A repetition of 3 consecutive characters or more is not permitted<br>';
            str += '7) The password must contain alphanumeric character';
            SDLUtil.alert({
                title: 'Password Rules',
                msg: str,
            });
        },
    },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/anysvcmobile/request/RequestOther.vue